import axios, { CancelTokenSource } from 'axios'
import React, { useEffect, useRef, useState } from 'react'
import { IBookmarksSummary } from '../../../models/Bookmarks'
import BookmarksService from '../../../services/BookmarksService'
import Protected from '../../Protected'
import AwardInfo from './AwardInfo'
import { BOOKMARKSTYPES } from '../bookmarkstypes'
import useErrorHandler from '../../../hooks/useErrorHandler'
import FormErrorDisplay from '../../common/FormErrorMessages'
import Conditional from '../../common/Conditional'
import Loader from '../../common/Loader'
import '../Bookmarks.css'
import ProfileService from '../../../services/ProfileService'
import WorkplaceFooter from '../../common/WorkplaceFooter'
import { UserProfile } from '../../../models/Profile'
import { useHistory } from 'react-router-dom'
import { Button } from 'semantic-ui-react'
import { MainArticleLayout } from '../../../layouts/MainArticleLayout'

const Awards = () => {
  const [data, setData] = useState<IBookmarksSummary[]>([])
  const [userErrors, handleErrors] = useErrorHandler()
  const [hasMore, sethasMore] = useState(false)
  const [isLoadingMore, setIsLoadingMore] = useState(false)
  const mountedRef = useRef(false)
  const [isLoading, setIsLoading] = useState(true)
  const [userProfile, setUserProfile] = useState<UserProfile>()
  const { getCurrentUserProfile } = ProfileService
  const size = 10
  const history = useHistory()
  useEffect(() => {
    mountedRef.current = true
    const source = axios.CancelToken.source()
    fetchCurrentUserProfile(source)
      .then((profile) => {
        if (mountedRef.current) {
          setUserProfile(profile)
        }
      })
      .finally(() => {
        if (mountedRef.current) {
          setIsLoading(false)
        }
      })

    return () => {
      mountedRef.current = false
      if (source) {
        source.cancel('Operation cancelled')
      }
    }
  }, [])

  const fetchCurrentUserProfile = async (source: CancelTokenSource) => {
    return await getCurrentUserProfile(source).then((response) => {
      return response.result
    })
  }
  const getAwards = async (source?: CancelTokenSource) => {
    await BookmarksService.getBookmarks(
      { offset: data.length, size: size },
      { type: BOOKMARKSTYPES.AWARD },
      source
    ).then((response) => {
      if (mountedRef.current) {
        const res = response.result
        setData((old) => [...old, ...res.result])
        sethasMore(res.hasMore)
      }
    })
  }
  const loadMoreBookmarks = async () => {
    setIsLoadingMore(true)
    getAwards()
      .then(() => {
        setIsLoadingMore(false)
      })
      .catch((error) => {
        setIsLoadingMore(false)
        handleErrors(error)
      })
  }
  useEffect(() => {
    mountedRef.current = true
    const source = axios.CancelToken.source()
    getAwards(source)
      .then(() => {
        setIsLoading(false)
      })
      .catch((error) => {
        setIsLoading(false)
        handleErrors(error)
      })

    return () => {
      mountedRef.current = false
      if (source) {
        source.cancel('Operation cancelled')
      }
    }
  }, [])

  const deleteBookmark = (id: string) => {
    history.push('/my-account/bookmarks-delete?id=' + id + '&type=awards')
  }
  return (
    <Protected>
      <MainArticleLayout>
        <Conditional if={isLoading}>
          <Loader />
        </Conditional>
        <div className="content-wrapper">
          <FormErrorDisplay
            show={userErrors?.length > 0}
            errorsList={userErrors}
          />
          <article className="main">
            <AwardInfo />

            <Conditional if={data && data.length > 0}>
              <div className="table-wrapper">
                <table id="table-awards">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Award code and Title </th>
                      <th>Award summary page </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.length > 0 &&
                      data.map((item, index) => (
                        <tr key={index} className="cell-color">
                          <td>{item.createdOn}</td>

                          <td>
                            <a href={item.sourceUrl} target="blank">
                              {item.title}
                            </a>
                          </td>
                          <td>
                            <a href={item.summaryUrl} target="blank">
                              {item.summaryTitle}
                            </a>
                          </td>
                          <td className="float-right">
                            <Button
                              className="ui is-secondary button"
                              onClick={() => deleteBookmark(item.id)}
                            >
                              Delete
                            </Button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </Conditional>
            <Conditional if={hasMore}>
              <button
                onClick={loadMoreBookmarks}
                className="button is-primary"
                type="button"
                disabled={isLoadingMore}
              >
                Load more
              </button>
            </Conditional>
            <Conditional if={!hasMore && !isLoading && data.length > 0}>
              <p className="d-flex justify-content-center">
                <b>No more bookmarked awards</b>
              </p>
            </Conditional>

            <Conditional
              if={data.length <= 0 && !isLoading && userErrors?.length <= 0}
            >
              <p className="d-flex">You have no bookmarked awards.</p>
              <p></p>
            </Conditional>
          </article>
        </div>
        <p></p>
        <WorkplaceFooter userProfile={userProfile} isLoading={isLoading} />
      </MainArticleLayout>
    </Protected>
  )
}

export default Awards
